import { getRouteExportsFromEntry } from "../server/routeExportsFromEntry";
import { toAbsoluteUrl } from "../utils/toAbsolute";
var serverEntries = /* @__PURE__ */ new Map();
function loadServerEntry(serverEntry) {
  var loading = serverEntries.get(serverEntry);
  if (!loading) {
    loading = import(toAbsoluteUrl(serverEntry));
    serverEntries.set(serverEntry, loading);
  }
  return loading;
}
async function getRouteExports(serverEntry, routerRoot, routeFile) {
  var entry = await loadServerEntry(serverEntry);
  var exported = await getRouteExportsFromEntry(entry, routerRoot, routeFile);
  if (!exported) {
    var _ref;
    var _entry_default_options, _entry_default, _entry_default_default_options, _entry_default_default, _entry_default1;
    var routes = (_ref = entry === null || entry === void 0 ? void 0 : (_entry_default = entry.default) === null || _entry_default === void 0 ? void 0 : (_entry_default_options = _entry_default.options) === null || _entry_default_options === void 0 ? void 0 : _entry_default_options.routes) !== null && _ref !== void 0 ? _ref : entry === null || entry === void 0 ? void 0 : (_entry_default1 = entry.default) === null || _entry_default1 === void 0 ? void 0 : (_entry_default_default = _entry_default1.default) === null || _entry_default_default === void 0 ? void 0 : (_entry_default_default_options = _entry_default_default.options) === null || _entry_default_default_options === void 0 ? void 0 : _entry_default_default_options.routes;
    throw new Error(`[one] route ${routeFile} is missing from the built server entry route map (looked in: ${Object.keys(routes !== null && routes !== void 0 ? routes : {}).join(", ")})`);
  }
  return exported;
}
export {
  getRouteExports
};
//# sourceMappingURL=serverRouteModules.js.map
